import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';
const Toaster = ({ ...props }) => {
    const { theme = 'light' } = useTheme();
    return (_jsx(Sonner, { theme: theme, className: "toaster group", closeButton: true, richColors: true, toastOptions: {
            classNames: {
                // success: "bg-primary!",
                // closeButton: "bg-primary!",
                toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                description: 'group-[.toast]:text-muted-foreground',
                actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
            },
        }, ...props }));
};
export { Toaster };
